import type { FaireProductEntity } from "../../entity_types/product";

export const p_cehucv2dnk: FaireProductEntity = {
  token: "p_cehucv2dnk",
  type: "product",
  name: "Pickleball Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d18e10fa507dc1210f53cdd279e1bd40f31f3d38b1104d50a197c5255179d57f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/994125e01ac4a16926b4504f5beb9b905264bde3d48d224740f56ceef520df66.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:46.757Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
